import { notEmpty } from '@festina-life/core'
import { Button } from '@festina-life/ui/actions'
import { Card, CardBody, Stack, Typography } from '@festina-life/ui/structure'
import { type ReactNode, useCallback, useEffect, useRef } from 'react'

import { useMsal } from '../hooks/useMsal/useMsal'
import { APPLICATION_NAME } from '../utility/applicationName'

const loginRequest = { scopes: ['User.Read'] }
export const SIGN_OUT_PARAM = 'signout'

type Props = {
  logo: ReactNode
}

export function SignInPage({ logo }: Props) {
  const { accounts, login } = useMsal()
  const isLoginInProgress = useRef(false)

  const handleLogin = useCallback(async () => {
    isLoginInProgress.current = true
    await login(loginRequest)
    isLoginInProgress.current = false
  }, [login])

  useEffect(() => {
    const hasJustSignedOut = notEmpty(
      new URLSearchParams(window.location.search).get(SIGN_OUT_PARAM),
    )

    if (
      accounts.length === 0 &&
      !hasJustSignedOut &&
      !isLoginInProgress.current
    ) {
      void handleLogin()
    }
  }, [accounts.length, handleLogin])

  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <Card>
        <CardBody
          innerClassName="items-center text-center"
          gap="display"
          padding="display"
        >
          {logo}
          <Stack className="flex-col">
            <Typography as="h1" size="2xl">
              Festina Life
              <br />& Pension
            </Typography>
            <Typography as="h2" size="lg" intensity="secondary">
              {APPLICATION_NAME}
            </Typography>
          </Stack>
          <Button variant="primary" isFullWidth onClick={handleLogin}>
            Sign in
          </Button>
        </CardBody>
      </Card>
    </div>
  )
}
